import React from 'react';
import Missing from '../MediaDevices/Missing';

export default class SpecificDevices extends React.PureComponent {

    state = {
        devices: [],
        screenDevices: []
    }

    currentDeviceId = false;

    processRawDevices(rawDevices) {
        let devices = [];
        for(var i in rawDevices) {
            devices.push({
                data: rawDevices[i],
                status: 'closed'
            })
        }

        let rawScreenDevices = window.sdk.videoconf().getScreenDevices();

        let screenDevices = [];
        for(var i in rawScreenDevices) {
            screenDevices.push({
                data: rawScreenDevices[i],
                status: 'closed'
            })
        }

        this.setState({
            devices, screenDevices
        })
    }

    async componentDidMount() {

        window.sdk.event().on('availableRemoteDevices', async (devices) => {                       
            let rawDevices = await window.sdk.videoconf().getSpecificDevices(); 
            this.processRawDevices(rawDevices);                    
        })

        window.sdk.event().on('inviteToScreenshare', (device) => {
            //alert('Medecin want you to share your screen with ' + device.label);
            window.sdk.event().emit('modalOpen', {
              variant: 'alert',
              title: 'Partage d\'écran',
              content: 'Le médecin vous invite a partager votre écran pour le dispositif : ' + device.label,
              onConfirm: () => { 
                this.startScreenDevice(device);
                window.sdk.event().emit('modalClose')
              }
            });
            
        })

        let rawDevices = await window.sdk.videoconf().getSpecificDevices(); 
        
        this.processRawDevices(rawDevices);

        window.sdk.event().on('specificDevice', (status, deviceId) => {
            this.setStatus(status, deviceId);
        })
    }

    setStatus(status, deviceId) {
        const index = this.state.devices.findIndex(device => device.data.deviceId === deviceId);
        this.state.devices[index].status = status;
        if (status == 'started')
            this.currentDeviceId = deviceId;
        this.forceUpdate();
    }

    startDevice(device) {
        //TODO stop the current specific device
        window.sdk.videoconf().startSpecificDevice(device)
    }

    stopDevice = (deviceId) => {
        window.sdk.videoconf().stopSpecificDevice(deviceId);
    }

    startScreenDevice(device) {
        if(window.sdk.session().isMedecin()) {
            window.sdk.videoconf().sendScreenShareInvitation(device);            
        }
        else
            window.sdk.videoconf().startScreenShare(device);
    }
 
    render() {
        return (
            <React.Fragment>
                {this.state.devices.map((device, index) =>
                    <div key={device.data.deviceId}>
                        <button onClick={() => { this.startDevice(device.data) }}>{device.data.label} [ {device.status} ]</button>
                        {device.status == 'started' &&
                            <button onClick={() => { this.stopDevice(device.data.deviceId) }}>Close</button>
                        }
                    </div>
                )}

                {this.state.screenDevices.map((screenDevice, index) =>
                    <div key={screenDevice.data.id}>
                        <button onClick={() => { this.startScreenDevice(screenDevice) }}>{screenDevice.data.label}</button>
                        {screenDevice.status == 'started' &&
                            <button onClick={() => { this.stopDevice(screenDevice.data.id) }}>Close</button>
                        }
                    </div>
                )}



                <Missing />
                
            </React.Fragment>
        )
    }
}
